import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { getAuthHeaders } from '../../utils/authHeaders'

const API_URL = process.env.REACT_APP_BACKEND_URL

const GradeSelection = () => {
  const navigate = useNavigate()
  const [scenarioCounts, setScenarioCounts] = useState({})
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchScenarioCounts()
  }, [])

  const fetchScenarioCounts = async () => {
    try {
      const headers = await getAuthHeaders()
      const response = await fetch(
        `${API_URL}/api/admin/public/financial-scenarios`,
        { headers }
      )
      
      if (!response.ok) {
        throw new Error('Failed to load scenarios')
      }
      
      const data = await response.json()
      
      // Count scenarios per grade
      const counts = {}
      data.forEach(scenario => {
        counts[scenario.grade] = (counts[scenario.grade] || 0) + 1
      })
      
      setScenarioCounts(counts)
    } catch (err) {
      console.error('Error loading scenario counts:', err)
    } finally {
      setLoading(false)
    }
  }

  const grades = [
    { number: 1 },
    { number: 2 },
    { number: 3 },
    { number: 4 },
    { number: 5 },
    { number: 6 },
    { number: 7 },
    { number: 8 },
    { number: 9 },
  ].map(g => ({
    ...g,
    scenarios: scenarioCounts[g.number] || 0,
    available: (scenarioCounts[g.number] || 0) > 0
  }))

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 via-white to-blue-50">
      
      {/* Header */}
      <div className="bg-gradient-to-r from-green-600 to-green-500 text-white py-8">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="flex items-center justify-between">
              <div>
                <h1 className="text-3xl font-bold">Vyber si ročník</h1>
                <p className="text-green-100 mt-2">Interaktívne scenáre pre žiakov 1. – 9. ročníka</p>
              </div>
              <button
                onClick={() => navigate('/financial-literacy')}
                className="px-4 py-2 bg-white/20 hover:bg-white/30 rounded-lg transition text-sm font-medium"
              >
                ← Späť
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto">
          
          <div className="bg-blue-50 border-l-4 border-blue-400 p-4 rounded-lg mb-8">
            <p className="text-gray-700 text-sm">
              <strong>💡 Pre učiteľov:</strong> Každý ročník obsahuje scenáre prispôsobené vekovej úrovni žiakov. Scenáre sú voľne prístupné bez registrácie.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-6">
            {grades.map((grade) => (
              <button
                key={grade.number}
                onClick={() => grade.available && navigate(`/scenarios/${grade.number}`)}
                disabled={!grade.available}
                className={`p-6 rounded-xl border-2 transition-all ${
                  grade.available
                    ? 'bg-white border-green-400 hover:border-green-500 hover:shadow-lg cursor-pointer'
                    : 'bg-gray-50 border-gray-200 cursor-not-allowed opacity-60'
                }`}
              >
                <div className="text-center">
                  <div className={`text-5xl font-bold mb-3 ${
                    grade.available ? 'text-green-600' : 'text-gray-400'
                  }`}>
                    {grade.number}.
                  </div>
                  <div className="text-lg font-semibold text-gray-900 mb-2">
                    {grade.number}. ročník
                  </div>
                  {grade.available ? (
                    <div className="flex items-center justify-center gap-2 text-sm">
                      <span className="inline-block px-3 py-1 bg-green-100 text-green-700 rounded-full font-medium">
                        {grade.scenarios} {grade.scenarios === 1 ? 'scenár' : 'scenáre'}
                      </span>
                    </div>
                  ) : (
                    <div className="text-sm text-gray-500">
                      Pripravujeme
                    </div>
                  )}
                </div>
              </button>
            ))}
          </div>

          <div className="mt-12 bg-white rounded-xl shadow-lg p-6">
            <h3 className="font-bold text-gray-900 mb-4 text-center">Čoskoro pridáme ďalšie scenáre</h3>
            <p className="text-gray-600 text-sm text-center">
              Pracujeme na scenároch pre všetky ročníky základnej školy. Nové scenáre budú pridané priebežne počas celého roka.
            </p>
          </div>

        </div>
      </div>

    </div>
  )
}

export default GradeSelection
